import { render, staticRenderFns } from "./SelfServiceProvider.vue?vue&type=template&id=c1888e68&scoped=true&"
import script from "./SelfServiceProvider.vue?vue&type=script&lang=js&"
export * from "./SelfServiceProvider.vue?vue&type=script&lang=js&"
import style0 from "./SelfServiceProvider.vue?vue&type=style&index=0&id=c1888e68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1888e68",
  null
  
)

export default component.exports